import { plainDtos } from '@abg/shared';

import { CheckoutFormParams } from '../../store/booking-flow/types';

export const getForwardMailPayload = (
  reservationResponse: CheckoutFormParams,
): plainDtos.SendReservationEmailRequestDto => {
  return {
    confirmationNumber: reservationResponse?.checkoutconfirmationNumber,
    firstName: reservationResponse?.checkoutfirstName || '',
    lastName: reservationResponse?.checkoutlastName || '',
    email: reservationResponse?.checkoutemail || '',
  };
};

export const getForwardMailPayloadFromReservation = (
  reservation: plainDtos.DisplayReservationResponse,
): plainDtos.SendReservationEmailRequestDto => {
  const firstName = reservation?.customerInformation?.firstName || '';
  const lastName = reservation?.customerInformation?.lastName || '';
  const confirmationNumber = reservation?.confirmationNumber || '';
  return {
    confirmationNumber,
    firstName,
    lastName,
    email: '',
  };
};
